import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains.edit-domain', {
        url: '/edit-domain/:domainId',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageDomainsEditDomain'
        },
        resolve: {
            domain,
            domainId,
        }
    });
}

/** @ngInject */
function domain(domainId, domains) {
    return domains.find((domain) => domain.id === domainId);
}

/** @ngInject */
function domainId($stateParams) {
    return $stateParams.domainId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/edit-domain/edit-domain.state.js